import { render, staticRenderFns } from "./SchoolCreateSchoolTeam.vue?vue&type=template&id=109cc42c&"
import script from "./SchoolCreateSchoolTeam.vue?vue&type=script&lang=ts&"
export * from "./SchoolCreateSchoolTeam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports